import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import TooltipWrapper from '@shared/TooltipWrapper';
import DowLogo from '@src/assets/pbdj.png';

const OuterContainer = styled.div`
  padding: 10px 0px;
`;

const LogoContainer = styled.img`
  margin-left: -3px;
`

function ListWidget({
  list_group,
  list_id,
  list_name,
  thresholdValue,
  version,
}) {
  const tooltipContent = list_id;
  const isDJW = list_name && list_name.includes('DJW');
  const djwLogo = isDJW ? <LogoContainer src={DowLogo} height={20} /> : null

  return (
<div>
    <OuterContainer>
      <TooltipWrapper tooltip={tooltipContent} placement='bottom'>
        Match found in {list_group} - {list_name} - Version {moment(version, 'YYYYMMDD').format('MM>DD>YYYY')}
      </TooltipWrapper>
    </OuterContainer>
      {djwLogo}
    </div>
  );
}

ListWidget.propTypes = {
  value: PropTypes.number.isRequired,
  thresholdValue: PropTypes.number,
};

ListWidget.defaultProps = {
  thresholdValue: 0.5,
};

export default ListWidget;
